export const SOUND_CLIP_ENDPOINTS = {
  LIST: '/app/v1/sound-clips/',
  DETAIL: (id: number) => `/app/v1/sound-clips/${id}/`,
} as const
